import rodzajFelgi from '@components/search/inputs/rodzajFelgi'
import typOpony from '@components/search/inputs/typOpony'

const kola = {
    type: 'conditional',
    name: 'koła',
    conditions: { 'rodzaj-czesci': 'Koła' },
    inputs: [
        rodzajFelgi,
        typOpony,
    ],
}

export default kola